import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_739_2071)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_739_2071)",
				children: [
					/* @__PURE__ */ _jsx("ellipse", {
						cx: 15.2945,
						cy: 14.8012,
						rx: 13.8706,
						ry: 13.5805,
						fill: "url(#paint0_linear_739_2071)"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						rx: 13.5859,
						ry: 14.0219,
						transform: "matrix(0.46143 0.887177 -0.885216 0.465179 18.4668 13.6939)",
						fill: "url(#paint1_linear_739_2071)"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						rx: 13.6411,
						ry: 13.811,
						transform: "matrix(-0.462972 0.886373 -0.894178 -0.447712 21.5123 15.6305)",
						fill: "url(#paint2_linear_739_2071)"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						rx: 13.6323,
						ry: 13.8706,
						transform: "matrix(0.0144529 -0.999896 0.999904 0.0138547 16.5057 22.366)",
						fill: "url(#paint3_linear_739_2071)"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						rx: 13.857,
						ry: 13.6048,
						transform: "matrix(-0.997436 -0.0715686 0.0866642 -0.996238 22.1188 20.2398)",
						fill: "url(#paint4_linear_739_2071)"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						rx: 13.8946,
						ry: 13.6075,
						transform: "matrix(0.954666 -0.29768 0.309329 0.950955 13.9201 18.9065)",
						fill: "url(#paint5_linear_739_2071)"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.125 22.0934V12.9077H10.2557V14.6539H10.3513C10.5425 14.0798 10.8691 13.6253 11.3311 13.2904C11.7932 12.9555 12.3428 12.7881 12.9801 12.7881C13.6254 12.7881 14.181 12.9595 14.647 13.3024C15.113 13.6413 15.3939 14.0918 15.4894 14.6539H15.585C15.7404 14.0918 16.071 13.6413 16.5768 13.3024C17.0827 12.9595 17.6762 12.7881 18.3573 12.7881C19.2375 12.7881 19.9505 13.0712 20.4962 13.6373C21.0458 14.2034 21.3207 14.9569 21.3207 15.8978V22.0934H18.0227V16.7351C18.0227 16.3324 17.9211 16.0174 17.718 15.7902C17.5148 15.559 17.242 15.4433 16.8995 15.4433C16.5609 15.4433 16.292 15.559 16.0929 15.7902C15.8977 16.0174 15.8001 16.3324 15.8001 16.7351V22.0934H12.6455V16.7351C12.6455 16.3324 12.544 16.0174 12.3408 15.7902C12.1377 15.559 11.8649 15.4433 11.5223 15.4433C11.2953 15.4433 11.1001 15.4952 10.9368 15.5988C10.7735 15.7025 10.646 15.852 10.5544 16.0473C10.4668 16.2387 10.423 16.468 10.423 16.7351V22.0934H7.125Z",
				fill: "#1A204D"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.0278 25.3125H23.7868V20.3608H23.8345C23.962 20.6718 24.1432 20.9509 24.3782 21.1981C24.6172 21.4413 24.904 21.6346 25.2386 21.7781C25.5771 21.9177 25.9615 21.9875 26.3917 21.9875C27.0449 21.9875 27.6444 21.816 28.19 21.4731C28.7397 21.1303 29.1778 20.61 29.5044 19.9123C29.835 19.2146 30.0003 18.3355 30.0003 17.275C30.0003 16.1666 29.8271 15.2656 29.4805 14.5719C29.138 13.8782 28.6919 13.3698 28.1422 13.0469C27.5966 12.724 27.021 12.5625 26.4156 12.5625C25.9615 12.5625 25.5632 12.6422 25.2207 12.8017C24.8781 12.9572 24.5913 13.1665 24.3603 13.4296C24.1293 13.6888 23.954 13.9739 23.8345 14.2848H23.7629V12.6821H20.4888L20.4888 12.8786C20.7524 13.0133 20.9906 13.191 21.2033 13.4117C21.753 13.9778 22.0278 14.7314 22.0278 15.6723V25.3125ZM23.8883 18.4352C23.7728 18.1082 23.7151 17.7215 23.7151 17.275C23.7151 16.8205 23.7728 16.4318 23.8883 16.1088C24.0078 15.7819 24.1751 15.5327 24.3902 15.3613C24.6093 15.1859 24.8701 15.0981 25.1729 15.0981C25.4756 15.0981 25.7325 15.1859 25.9436 15.3613C26.1587 15.5327 26.322 15.7819 26.4335 16.1088C26.549 16.4318 26.6068 16.8205 26.6068 17.275C26.6068 17.7295 26.549 18.1202 26.4335 18.4471C26.322 18.7701 26.1587 19.0192 25.9436 19.1947C25.7325 19.3661 25.4756 19.4518 25.1729 19.4518C24.8701 19.4518 24.6093 19.3641 24.3902 19.1887C24.1751 19.0093 24.0078 18.7581 23.8883 18.4352Z",
				fill: "#1A204D"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_739_2071",
			x1: 21.1474,
			y1: -1.6053,
			x2: -3.69582,
			y2: 37.939,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .20625,
				stopColor: "#D5CEFF",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0D25FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_739_2071",
			x1: 19.3186,
			y1: -2.91786,
			x2: -6.8959,
			y2: 36.6658,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .20625,
				stopColor: "#D5CEFF",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0D25FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_739_2071",
			x1: 19.3972,
			y1: -2.87397,
			x2: -6.22608,
			y2: 36.5677,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .20625,
				stopColor: "#D5CEFF",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0D25FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_739_2071",
			x1: 19.3846,
			y1: -2.88637,
			x2: -6.40085,
			y2: 36.6087,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .20625,
				stopColor: "#D5CEFF",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0D25FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_739_2071",
			x1: 19.7042,
			y1: -2.83106,
			x2: -5.21348,
			y2: 36.7218,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .20625,
				stopColor: "#D5CEFF",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0D25FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_739_2071",
			x1: 19.7576,
			y1: -2.83161,
			x2: -5.1378,
			y2: 36.7854,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .20625,
				stopColor: "#D5CEFF",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0D25FF"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_739_2071",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_739_2071",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				fill: "white"
			})
		})
	] })]
});
export default SvgLogo;
